(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Off-screen slides are deferred via data-src; populate the real source the
  // first time a slide is needed (opacity-stacked images would otherwise all
  // fetch on load and compete with the eager hero image).
  function loadSlide(s) {
    if (s && s.getAttribute('data-src')) {
      s.src = s.getAttribute('data-src');
      var ss = s.getAttribute('data-srcset');
      if (ss) { s.srcset = ss; }
      s.removeAttribute('data-src');
      s.removeAttribute('data-srcset');
    }
  }

  function initGallery(g) {
    if (g.dataset.pdpInit) { return; }
    g.dataset.pdpInit = '1';

    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-pdp-slide]'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-pdp-thumb]'));
    var counter = g.querySelector('[data-pdp-current]');
    var prev = g.querySelector('[data-pdp-prev]');
    var next = g.querySelector('[data-pdp-next]');
    var main = g.querySelector('[data-pdp-main]');
    if (slides.length < 2) { return; }
    var idx = 0;

    function show(n) {
      idx = (n + slides.length) % slides.length;
      loadSlide(slides[idx]);
      loadSlide(slides[(idx + 1) % slides.length]); // preload the likely-next image
      slides.forEach(function (s, i) {
        var on = i === idx;
        s.classList.toggle('is-active', on);
        if (on) { s.removeAttribute('aria-hidden'); } else { s.setAttribute('aria-hidden', 'true'); }
      });
      thumbs.forEach(function (t, i) {
        var on = i === idx;
        t.classList.toggle('is-active', on);
        if (on) { t.setAttribute('aria-current', 'true'); } else { t.removeAttribute('aria-current'); }
      });
      if (counter) { counter.textContent = idx + 1; }
    }

    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    if (prev) { prev.addEventListener('click', function () { show(idx - 1); }); }
    if (next) { next.addEventListener('click', function () { show(idx + 1); }); }

    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(idx + 1); }
    });

    var x0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) { return; }
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { show(idx + (dx < 0 ? 1 : -1)); }
        x0 = null;
      }, { passive: true });
    }

    // Preload the second image so the first "next"/swipe is instant.
    loadSlide(slides[1]);
  }

  function boot() {
    document.querySelectorAll('[data-pdp-gallery]').forEach(initGallery);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Re-init when the section is re-rendered in the Shopify theme editor.
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vault-volumes"] && !Shopify.designMode) return;
  try {
    
(function () {
  // Smooth-scroll to the Join the Club sign-up ONLY when a coming-soon volume
  // is clicked — never affects normal page scrolling.
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href="#join-club"]');
    if (!link) { return; }
    var target = document.getElementById('join-club');
    if (!target) { return; }
    e.preventDefault();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
